import { useContext } from "react";

import { ApiContext } from "../../api-context";

export const LoadingTopBar: React.FC = () => {
  const { isLoading } = useContext(ApiContext);

  const style: React.CSSProperties = {
    ...(isLoading && {
      backgroundColor: "#ffc107",
      animation: "1s ease-in-out infinite running loadingBar",
    }),
  };

  return <div className="loading-top-bar" style={style} />;
};
